import { render, staticRenderFns } from "./ChartIframe.vue?vue&type=template&id=c6bff644&scoped=true"
import script from "./ChartIframe.vue?vue&type=script&lang=js"
export * from "./ChartIframe.vue?vue&type=script&lang=js"
import style0 from "./ChartIframe.vue?vue&type=style&index=0&id=c6bff644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bff644",
  null
  
)

export default component.exports